import { IIconProps } from "@/models";
import { SvgIcon } from "@mui/material";
import { memo } from "react";

const ScreenShareIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 25"
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        d="M21 12.3252V15.3252C21 15.5904 20.8946 15.8448 20.7071 16.0323C20.5196 16.2198 20.2652 16.3252 20 16.3252H4C3.73478 16.3252 3.48043 16.2198 3.29289 16.0323C3.10536 15.8448 3 15.5904 3 15.3252V5.3252C3 5.05998 3.10536 4.80563 3.29289 4.61809C3.48043 4.43055 3.73478 4.3252 4 4.3252H13M7 20.3252H17M9 16.3252V20.3252M15 16.3252V20.3252M17 4.3252H21M21 4.3252V8.3252M21 4.3252L16 9.3252"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default memo(ScreenShareIcon);
